import type { Routes } from '@angular/router';
import { authGuard, courtAdminGuard, userInfoResolver } from './core/services';

export const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  {
    path: 'home',
    loadComponent: () => import('./features/home/pages/home/home.component'),
    canActivate: [authGuard],
    resolve: { userInfo: userInfoResolver },
  },
  {
    path: 'citations-history',
    loadChildren: () => import('./features/citations-history/pages/citations-history.routing'),
    canActivate: [authGuard],
  },
  {
    path: 'activity-log',
    loadComponent: () => import('./features/activity-log/pages/activity-log/activity-log.component'),
    canActivate: [authGuard, courtAdminGuard],
  },
  {
    path: 'date-management',
    loadChildren: () => import('./features/date-management/pages/date-management.routing'),
    canActivate: [authGuard, courtAdminGuard],
  },
  {
    path: 'user-management',
    loadChildren: () => import('./features/user-management/pages/user-management.routing'),
    canActivate: [authGuard, courtAdminGuard],
  },
  {
    path: 'court/:id',
    loadChildren: () => import('./features/citation/pages/citation.routing'),
    canActivate: [authGuard],
  },
  {
    path: 'errors',
    loadChildren: () => import('./features/errors/pages/errors.routing'),
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
